<template>
    <form-select
        v-bind="select_props"
        :options="options"
        v-on="$listeners"
    >
        <template v-slot:read_only><slot name="read_only"></slot></template>
        <template v-slot:label><slot name="label"></slot></template>
        <template v-slot:hint><slot name="hint"></slot></template>
    </form-select>
</template>

<script>
import { mapGetters } from "vuex"
import { orderBy } from "lodash"

import FormSelect from "./FormSelect"

const { options, labelField, ...select_props } = FormSelect.props

export default {
    components: {
        FormSelect
    },
    computed: {
        ...mapGetters(["entity_records"]),
        raw_user_records () {
            return this.entity_records("user")
        },
        select_props () {
            const { options, filter, ...select_props } = this.$props
            return select_props
        },
        options () {
            const users = this.raw_user_records.filter(user => {
                if(user.id === this.value) return true
                if(!!user.deleted_at || !!user.currently_on_leave) return false
                if(this.filter) return this.filter(user)
                return true
            })

            return orderBy([...users, ...this.extraUsers], this.labelField, "asc")
        }
    },
    props: {
        ...select_props,
        labelField: {
            type: String,
            default: "initials"
        },
        filter: {
            type: Function /* (user) => { return true/false } */
        },
        extraUsers: {
            type: Array,
            default () {
                return []
            }
        }
    }
}
</script>
